// extracted by mini-css-extract-plugin
export var banner = "_sy-0";
export var settingRow = "_sy-2";
export var titleIcon = "_sy-1";